import { getAppState } from "../state/useAppState";

export const REVOKED_API_KEY_ERROR_CODE = "revoked_api_key";
export const REVOKED_API_KEY_ROUTE = "/api-key-disabled";

export type ApiErrorResponse = {
    message?: string;
    error_code?: string | null;
    status_code?: number;
};

export const isRevokedApiKeyError = (errorData: ApiErrorResponse, status?: number) => {
    return status === 401 && errorData.error_code === REVOKED_API_KEY_ERROR_CODE;
};

export const redirectToRevokedApiKeySplash = () => {
    getAppState().clearAuth();

    if (window.location.pathname !== REVOKED_API_KEY_ROUTE) {
        window.location.replace(REVOKED_API_KEY_ROUTE);
    }
};

export const getApiErrorResponse = async (response: Response): Promise<ApiErrorResponse> => {
    return response
        .clone()
        .json()
        .catch(() => ({}));
};

export const ensureSuccessfulResponse = async (response: Response, fallbackMessage: string) => {
    if (response.ok) {
        return;
    }

    const errorData = await getApiErrorResponse(response);

    if (isRevokedApiKeyError(errorData, response.status)) {
        redirectToRevokedApiKeySplash();
    }

    const error = new Error(errorData.message || fallbackMessage);
    error.cause = {
        status: response.status,
        errorData,
    };
    throw error;
};
